// extracted by mini-css-extract-plugin
export default {"tooltip":"kU-z","arrow":"lU-z"};